"use strict";
/**
 * @file Created on 20.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var WindowSimulation_1 = require("../../../window/model/WindowSimulation");

var NotificationDoc_1 = require("../NotificationDoc");
/**
 * @author Tomas Leity
 */


var NSimulationWindowDTO =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NSimulationWindowDTO, _NotificationDoc_1$No);

  /**
   * @param windowId
   * @param windowName
   * @param windowExternalId
   * @param simulation
   */
  function NSimulationWindowDTO(windowId, windowName, windowExternalId, simulation) {
    var _this;

    _classCallCheck(this, NSimulationWindowDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NSimulationWindowDTO).call(this));
    _this.windowId = windowId;
    _this.windowName = windowName;
    _this.windowExternalId = windowExternalId;
    _this.simulation = simulation;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NSimulationWindowDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NSimulationWindowDTO(mat.windowId, mat.windowName, mat.windowExternalId, mat.simulation);
    }
  }]);

  return NSimulationWindowDTO;
}(NotificationDoc_1.NotificationDoc);

exports.NSimulationWindowDTO = NSimulationWindowDTO;

NSimulationWindowDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NSimulationWindowDTO.name);
  return {
    windowId: builder.id('windowId'),
    windowName: builder.str('windowName'),
    windowExternalId: builder.str('windowExternalId'),
    simulation: builder.obj('simulation', WindowSimulation_1.WindowSimulation.schema, function (mat) {
      return WindowSimulation_1.WindowSimulation.fromDataDict(mat);
    })
  };
}();